import { ajaxTransport, data } from "jquery";
import React, { useEffect, useState, useContext } from "react";
import {
  Link,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { productDetailsCall, dealProductDetail } from "../Services/Service";
import { FaStar } from "react-icons/fa";
import "./Home.css";
import { ProductSlider } from "./Slider";
import { addedToCart as adds } from "../Services/Service";
import UserContext from "../context/UserContext";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { Tabs } from "./Tabs";
import Backdrop from "@mui/material/Backdrop";
import Spinner from "./Spinner";
import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { add_to_cart, select_item, view_item } from "../Services/events";
import Modal from "react-modal";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import BottomLogin from "./bottomLogin";
import "./chkraProdDetail.css";
const ChakraProductDetails = () => {
  const [loading, setLoading] = React.useState(true);
  const [tabsLists, setTabLists] = useState([]);
  const [cartMessage, setCarMessage] = useState({});
  const location = useLocation();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [isApplied, setIsApplied] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [similarPrd, setSimilarPrd] = useState([]);
  const [productQty, setProductQty] = useState(1);
  const [coupons, setCoupons] = useState([]);
  const [coupon, setCoupon] = useState({});
  const { state, updateCartCount } = useContext(UserContext);
  const [rate, setRate] = useState(0);
  const queryParams = new URLSearchParams(location.search);
  const [show, setShow] = useState(false);
  const copId = queryParams.get("couponId");
  const isDiscount = queryParams.get("deal");
  const { id } = useParams();
  const [imageSet, setImageSet] = useState([]);
  const [alertInfo, setAlertInfo] = useState({
    visible: false,
    cls: "",
    msg: "",
  });
  const [canProceed, setCanProceed] = useState("N");
  const [showRedeem, setShowRedeem] = useState("N");
  const [canAddToCart, setCanAddToCart] = useState("N");
  const isLoggedIn = localStorage.getItem("auth") ? true : false;
  const [showLoginModal, setShowLoginModal] = useState(false);

  const fetchProductDetails = async (id, copId) => {
    setLoading(true);
    productDetailsCall(id, copId)
      .then((res) => {
        console.log("productDetailsCall response:", res.data.coupons);
        setServiceData({
          type: res.data.data[0].type,
          category: res.data.data[0].productTitle,
          description: res.data.data[0].productDesc,
          skuId: res.data.data[0].skuId,
          image: res.data.data[0].productImageArr,
          price: res.data.data[0].productPrice,
          title: res.data.data[0].productTitle,
          id: res.data.id,
          count: res.data.count,
          offerPrice: res.data.data[0].offerPrice,
          discountAmount: res.data.data[0].discountAmount,
          vendorName: res.data.data[0].vendorName,
          variantValue: res.data.data[0].variantValue,
          productStock: res.data.data[0].productStock,
          variantType: res.data.data[0].variantType,
          totalStock: res.data.data[0].totalStock,
          canRedeem: res.data.canRedeem,
          shippingPrice: res.data.data[0].shippingPrice,
          newPrice: res.data.data[0].newPrice,
          canAddToCart: res.data.canAddToCart,
          canAddToCartMessage: res.data.canAddToCartMessage,
          productId: res.data.data[0].productId,
          showPrice: res.data.data[0].showPrice,
        });
        setRate(res.data.data[0].offerPrice);
        setImageSet(res.data.data[0].productImageArr);
        setSimilarPrd(res.data.data[0].siblingProductArrs);
        setCoupons(res.data.coupons);
        if (res.data.showRedeem !== undefined) {
          setShowRedeem(res.data.showRedeem);
        }
        // console.log(res.data.data[0].productId, "productid");

        if (res.data.canRedeem !== undefined) {
          setCanProceed(res.data.canRedeem);
        }

        if (res.data.canAddToCart !== undefined) {
          setCanAddToCart(res.data.canAddToCart);
        }

        return res;
      })
      .then((res) => {
        const arr = [];
        for (const property in res.data.data[0].label) {
          const x = {};
          x.label = property;
          x.content = res.data.data[0].label[property];
          if (x.content !== "-" && x.content) {
            arr.push(x);
          }
        }
        select_item(res.data.data);
        view_item(res.data.data);
        setTabLists([...arr]);
        setLoading(false);
      });
  };

  const fetchDealProductDetails = async (id, copId) => {
    setLoading(true);
    dealProductDetail(id)
      .then((res) => {
        setServiceData({
          type: res.data.data[0].type,
          category: res.data.data[0].productTitle,
          description: res.data.data[0].productDesc,
          skuId: res.data.data[0].skuId,
          image: res.data.data[0].productImageArr,
          price: res.data.data[0].productPrice,
          title: res.data.data[0].productTitle,
          id: res.data.id,
          count: res.data.count,
          offerPrice: res.data.data[0].offerPrice,
          discountAmount: res.data.data[0].discountAmount,
          vendorName: res.data.data[0].vendorName,
          variantValue: res.data.data[0].variantValue,
          productStock: res.data.data[0].productStock,
          variantType: res.data.data[0].variantType,
          totalStock: res.data.data[0].totalStock,
          canAddToCart: res.data.canAddToCart,
          canAddToCartMessage: res.data.canAddToCartMessage,
          shippingPrice: res.data.data[0].shippingPrice,
          productId: res.data.data[0].productId,
        });
        setRate(res.data.data[0].offerPrice);
        setImageSet(res.data.data[0].productImageArr);
        setSimilarPrd(res.data.data[0].siblingProductArrs);
        setCoupons(res.data.couponDetails);
        console.log("Available coupons:", res.data.data[0].productId);
        console.log(res.data.canAddToCartMessage, "servicedataa deal");

        if (res.data.showRedeem !== undefined) {
          setShowRedeem(res.data.showRedeem);
        }

        if (res.data.canProceed !== undefined) {
          setCanProceed(res.data.canProceed);
        }

        if (res.data.canAddToCart !== undefined) {
          setCanAddToCart(res.data.canAddToCart);
        }
        return res;
      })
      .then((res) => {
        const arr = [];
        for (const property in res.data.data[0].label) {
          const x = {};
          x.label = property;
          x.content = res.data.data[0].label[property];
          if (x.content !== "-" && x.content) {
            arr.push(x);
          }
        }
        select_item(res.data.data);
        view_item(res.data.data);
        setTabLists([...arr]);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (isDiscount && isDiscount !== "all") {
      fetchDealProductDetails(id);
    } else {
      fetchProductDetails(id, copId);
    }

    setProductQty(1);
  }, [id, copId, isDiscount]);
  console.log(id, serviceData, "serviceData");
  const handleChange = (qty, d) => {
    const newQty = qty + d;
    if (newQty >= 1 && newQty <= serviceData.productStock) {
      setProductQty(newQty);
    }
  };

  const addedToCart = (e, type, skuId, couponId = 0) => {
    e.preventDefault();
    couponId = copId !== null ? copId : 0;
    setLoading(true);
    adds(id, productQty, type, skuId, 0, couponId)
      .then((res) => {
        setLoading(false);

        // Check both code and status fields for success
        const isSuccess =
          res.data.status === 1 ||
          (res.data.code === 200 && res.data.status !== 0);

        setOpen(true);
        setCarMessage({
          msg: res.data.msg || "Item added to cart",
          status: isSuccess ? 1 : 0,
        });

        // Only proceed with success actions if status === 1 or code === 200
        if (isSuccess) {
          try {
            add_to_cart(
              serviceData.offerPrice,
              id,
              type,
              serviceData.title,
              productQty
            );
            updateCartCount();

            if (e.currentTarget.id === "buy" || e.target.id === "buy") {
              setTimeout(() => {
                nav("/cart");
              }, 500);
            }
          } catch (error) {
            console.error("Error in success actions:", error);
            // Don't show error message if product was added successfully
            // Just log the error
          }
        }

        setTimeout(
          () => {
            setOpen(false);
          },
          isSuccess ? 2000 : 5000
        );
      })
      .catch((error) => {
        setLoading(false);

        // Only show error if it's not a successful response
        const responseData = error.response?.data;
        const isSuccess =
          responseData?.status === 1 ||
          (responseData?.code === 200 && responseData?.status !== 0);

        if (!isSuccess) {
          setOpen(true);
          setCarMessage({
            msg:
              responseData?.msg ||
              "An error occurred while adding to cart. Please try again.",
            status: 0,
          });
          setTimeout(() => {
            setOpen(false);
          }, 5000);
        } else {
          // If response is successful but axios threw error, treat as success
          setOpen(true);
          setCarMessage({
            msg: responseData?.msg || "Item added to cart",
            status: 1,
          });
          try {
            add_to_cart(
              serviceData.offerPrice,
              id,
              type,
              serviceData.title,
              productQty
            );
            updateCartCount();
          } catch (err) {
            console.error("Error in success actions:", err);
          }
          setTimeout(() => {
            setOpen(false);
          }, 2000);
        }
      });
  };

  const handleAddToCartClick = (e, type, skuId, couponId) => {
    if (!isLoggedIn) {
      setShowLoginModal(true);
    } else {
      addedToCart(e, type, skuId, couponId);
    }
  };

  const newArray = imageSet?.map((i) => ({
    original: i.image,
    thumbnail: i.image,
  }));
  const currentPath = window.location.pathname;
  const handleProductClick = (productId) => {
    if (isDiscount && isDiscount !== "all") {
      nav(`/chakra/productdetails/${productId}?deal=${isDiscount}`, {
        replace: true,
      });
    } else {
      nav(`/chakra/productdetails/${productId}`, { replace: true });
    }
  };

  return (
    <div className="content-app">
      <>
        <Snackbar
          sx={{
            height: 300,
          }}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={open}
          TransitionComponent={Slide}
          autoHideDuration={cartMessage.status === 0 ? 5000 : 2000}
          onClose={() => setOpen(false)}
        >
          <Alert
            severity={
              cartMessage.status === 0
                ? "error"
                : cartMessage.status === 1
                ? "success"
                : "error"
            }
            onClose={() => setOpen(false)}
          >
            <AlertTitle>
              {cartMessage.status === 0
                ? "Unable to Add to Cart"
                : cartMessage.status === 1
                ? "Success"
                : ""}
            </AlertTitle>
            {cartMessage.msg}
          </Alert>
        </Snackbar>
        <Snackbar
          sx={{
            height: 400,
          }}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={isApplied}
          TransitionComponent={Slide}
        >
          <Alert severity="success">
            <AlertTitle></AlertTitle>
            {coupon.percentage}% Off <strong>coupon applied</strong>
          </Alert>
        </Snackbar>
        <HelmetProvider>
          <Helmet>
            <title>ProductDetails</title>
          </Helmet>
        </HelmetProvider>

        <Modal
          isOpen={show}
          onRequestClose={() => setShow(false)}
          contentLabel="Leaderboard"
          className="coupon-modal"
          overlayClassName="leaderboard-overlay"
        >
          <div className="modal-head" style={{ top: "-10px" }}>
            <h3>Gamers Club</h3>
          </div>
          <button
            className="close-button"
            style={{ top: "0" }}
            onClick={() => setShow(false)}
          >
            <i class="fa fa-times" style={{ color: "white" }}></i>
          </button>
          <div
            className="popup-content mt-2"
            style={{
              overflowY: "scroll",
              width: "100%",
              border: "none",
              maxHeight: "62vh",
            }}
          >
            <div className="row mr-2 ">
              {coupons?.map((item, i) => {
                return (
                  <div className="col-sm-6 col-md-4 col-lg-4">
                    <div
                      style={{
                        margin: "4px",
                        display: "block",
                        position: "relative",
                        fontSize: "14px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        width: "35vh",
                        display: "flex",
                        justifyContent: "center",
                        color:
                          item.subCouponId === coupon.subCouponId
                            ? "black"
                            : "",
                      }}
                    >
                      <img
                        src={
                          coupon === item
                            ? "/assets/images/coupon5-selected.png"
                            : "/assets/images/coupon4.png"
                        }
                        style={{ width: "35vh" }}
                        alt="coupon"
                      ></img>
                      <span
                        style={{
                          top: "1vh",
                          left: "8vh",
                          position: "absolute",
                          width: "25vh",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "3vh",
                            fontWeight: "bold",
                            marginLeft: "0",
                          }}
                        >
                          {item.percentage}% off
                        </span>
                        <p style={{ fontSize: "1.5vh", fontWeight: "300" }}>
                          claim upto {item.discountCapacityLimit}₹
                        </p>{" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <button
                            style={{
                              backgroundColor:
                                item.subCouponId === coupon.subCouponId
                                  ? "var(--background-color)"
                                  : "",
                            }}
                            className="apply-btn"
                            value={item.percentage}
                            onClick={() => {
                              setCoupon(item);
                              setIsApplied(true);
                              setTimeout(() => {
                                setIsApplied(false);
                              }, 2000);
                              nav(
                                `${currentPath}?couponId=${item.subCouponId}`
                              );
                            }}
                          >
                            {item.subCouponId === coupon.subCouponId &&
                            item.discountCapacityLimit ===
                              coupon.discountCapacityLimit &&
                            item.tier == coupon.tier
                              ? "Applied"
                              : "Apply"}
                          </button>
                          <span
                            style={{
                              fontSize: "1.5vh",
                              fontWeight: "400",
                              color: "black",
                              marginLeft: "2px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: " center",
                              }}
                            >
                              2hr left
                            </div>
                          </span>
                        </div>
                      </span>
                      <span
                        style={{
                          top: "6vh",
                          left: "1vh",
                          position: "absolute",
                          rotate: "-90deg",
                        }}
                      >
                        <span>Tier {item.tier}</span>
                        {/* <p><button  value={item.percentage}   onClick={() => setCoupon(item.subCouponId)}>Apply</button></p> */}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </Modal>

        <div className="container product-details-container">
          <div className="product-details py-4">
            <div className="row g-4 align-items-start">
              {/* Left Section - Images */}
              <div className="col-lg-5 col-md-6 col-12">
                <div className="product-img-detail shadow-sm rounded-4 overflow-hidden">
                  {imageSet.length > 1 ? (
                    <ReactImageGallery
                      showPlayButton={false}
                      items={newArray}
                    />
                  ) : (
                    <ProductSlider imagesArr={serviceData.image} />
                  )}
                </div>
              </div>

              {/* Right Section - Info */}
              <div className="col-lg-7 col-md-6 col-12 mt-0">
                <div className="details-content px-2 pb-3 p-3">
                  {/* Vendor Info */}
                  {/* <p className="text-muted mb-1 fs-6">
                    Sold by:{" "}
                    <span className="text-light">{serviceData.vendorName}</span>{" "}
                    | Origin: <span className="text-light">India</span>
                  </p> */}

                  {/* Product Title */}
                  <h2 className="product-name fs-4 fw-bold text-light mt-2">
                    {serviceData.title}
                  </h2>

                  {/* Price Section */}
                  {serviceData.productId !==
                    "VW9TUlFaNU9nUlRvTTV3LzNnbSs1Zz09" && (
                    <div className="product-price mb-2">
                      <span className="text-secondary me-2">MRP:</span>
                      {serviceData.offerPrice !== serviceData.price ? (
                        <>
                          <span className="text-decoration-line-through text-muted">
                            ₹ {serviceData.newPrice}
                          </span>
                        </>
                      ) : (
                        <span className="fw-semibold text-success">
                          ₹ {serviceData.newPrice}
                        </span>
                      )}
                    </div>
                  )}

                  {/* Shipping Charges */}
                  <div className="shipping-charges mb-2">
                    <span className="text-secondary me-2">
                      Shipping Charges:
                    </span>
                    <span className="fw-semibold text-light">
                      {parseFloat(serviceData.shippingPrice) === 0 ? (
                        <span className="text-success">FREE</span>
                      ) : (
                        `₹ ${serviceData.shippingPrice}`
                      )}
                    </span>
                  </div>

                  {/* Redeem Section */}
                  {serviceData.offerPrice !== serviceData.price && (
                    <div className="redeem-box mt-2 mb-3 p-2 rounded">
                      {Object.keys(coupon).length !== 0 ? (
                        <>
                          <span className="text-light">
                            -- : ₹
                            {serviceData.price -
                              Math.floor(
                                serviceData.price * (coupon.percentage / 100)
                              )}
                          </span>
                          <span className="t-red ms-2">
                            <img
                              src={"/assets/images/spicegold.png"}
                              alt=""
                              className="spice-icon"
                            />{" "}
                            {Math.floor(
                              serviceData.price * (coupon.percentage / 100)
                            )}
                          </span>
                        </>
                      ) : (
                        <div
                          className="d-flex flex-column align-items-center text-center p-3 border rounded shadow-sm"
                          style={{
                            // Styles to match the image's dark container and light border
                            backgroundColor: "#1E3A34", // Dark green/black background color from the image
                            borderColor: "#FFFFFF", // White border color
                            borderWidth: "2px", // Slightly thicker border for visibility
                            borderStyle: "solid",
                            maxWidth: "300px", // Optional: Set a max-width for better centering/framing
                            margin: "auto", // Optional: Center the box
                          }}
                        >
                          {/* Header: Redeem for : */}
                          <small
                            className="text-uppercase mb-2"
                            style={{
                              letterSpacing: "0.5px",
                              color: "#FFC107", // Gold/Yellow color for "Redeem for :"
                              fontWeight: "600",
                              fontSize: "14px",
                            }}
                          >
                            Redeem for :
                          </small>

                          <div className="d-flex flex-column">
                            {/* Strikethrough Price: 40000.00 */}
                            <span
                              style={{
                                color:
                                  serviceData.price !== serviceData.showPrice
                                    ? "#545454" // Gray color for strikethrough price
                                    : "#FFFFFF", // White color if it's the only price
                                textDecoration:
                                  serviceData.price !== serviceData.showPrice
                                    ? "line-through"
                                    : "none",
                                fontSize: "1.5rem", // Slightly larger font for the main price lines
                                fontWeight: "bold",
                              }}
                              // Use classes for styling and layout
                              className="mb-1 d-flex justify-content-center align-items-center"
                            >
                              <img
                                src={"/assets/images/spicegold.png"}
                                alt="SpiceGold Icon"
                                className="spice-icon me-1"
                                style={{
                                  width: "28px",
                                  height: "28px",
                                }}
                              />
                              {serviceData.showPrice}{" "}
                              {/* This will be 40000.00 if a deal exists */}
                            </span>

                            {/* Actual Price and Special Deal Label */}
                            {serviceData.showPrice !== serviceData.price && (
                              <div className="mb-0 d-flex flex-column align-items-center">
                                {/* Actual Price: 40001 */}
                                <span
                                  className="fw-bold h3 mb-1 d-flex justify-content-center align-items-center"
                                  style={{ color: "#FFFFFF" }} // White color for the actual deal price
                                >
                                  <img
                                    src={"/assets/images/spicegold.png"}
                                    alt="SpiceGold Icon"
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                    }}
                                    className="me-1"
                                  />
                                  {serviceData.price}{" "}
                                  {/* This will be 40001 in the image's case */}
                                </span>

                                {/* Special Deal! Label */}
                                <small style={{ color: "#ffd900ff" }}>
                                  Special Deal!
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="text-muted small mt-1">
                        Inclusive of all taxes
                      </div>
                    </div>
                  )}

                  {/* Stock Info */}

                  {serviceData.productStock < 100000 ? (
                    <div className="stock-info mb-2">
                      <span className="text-warning fw-semibold">
                        {serviceData.productStock}
                      </span>{" "}
                      / {serviceData.totalStock} Left in stock
                    </div>
                  ) : serviceData.productStock <= 0 ? (
                    <p className="text-primary small fw-semibold">
                      Out of Stock
                    </p>
                  ) : null}
                  {id === "azJwUmdRZzBRQlNhYklnVlBULzJPdz09" && (
                    <div className="alert small alert-info mt-2" role="alert">
                      Each player can only have one active FBP Pass. If you
                      already have a valid pass, you won’t receive another one.
                      Please do not proceed with redemption if your current pass
                      is still active.
                    </div>
                  )}
                  {/* Product Disclaimer */}
                  <div className="product-disclaimer mt-2 mb-3">
                    <p className="text-muted small">
                      Note : Images shown here are for representation purposes
                      only. The actual product may differ due to limitations of
                      colour reproduction on the screen, changes made by the
                      manufacturer / seller or due to storage of products over
                      time as well as other unforeseen reasons.
                    </p>
                  </div>

                  {/* Variants */}
                  {similarPrd?.length > 0 && (
                    <div className="size-section mt-3 border-top pt-3">
                      <h5 className="product-size mb-2">
                        {serviceData.variantType}
                      </h5>
                      <div className="d-flex flex-wrap gap-2">
                        {similarPrd?.map((data) => (
                          <button
                            key={data.productId}
                            disabled={!data.productStock}
                            className={`variant-btn ${
                              data.variantValue === serviceData.variantValue
                                ? "active"
                                : ""
                            }`}
                            onClick={() => handleProductClick(data.productId)}
                          >
                            {data.variantType === "Price:"
                              ? `₹${data.variantValue}`
                              : data.variantValue}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Quantity + Buttons */}
            {serviceData.productStock > 0 && (
              <>
                <div className="d-flex flex-wrap justify-content-between align-items-center py-3 border-top border-secondary">
                  {/* Quantity */}
                  <div className="quentity">
                    <div className="mb-2">Qty:</div>
                    <div>
                      <input
                        type="button"
                        value="-"
                        className="qty-btn"
                        disabled={productQty === 1}
                        onClick={() => handleChange(productQty, -1)}
                      />
                      <label className="mx-2">{productQty}</label>
                      <input
                        type="button"
                        value="+"
                        className="qty-btn"
                        disabled={productQty >= serviceData.productStock}
                        onClick={() => handleChange(productQty, 1)}
                      />
                    </div>
                  </div>

                  {/* Buttons */}
                  <div className="action-buttons text-center mt-3 mt-md-0">
                    <div className="d-flex gap-2 justify-content-center">
                      <button
                        id="buy"
                        disabled={
                          isLoggedIn &&
                          (loading ||
                            canAddToCart !== "Y" ||
                            serviceData.canAddToCart === "N" ||
                            canProceed !== "Y")
                        }
                        onClick={(e) =>
                          handleAddToCartClick(
                            e,
                            serviceData.type,
                            serviceData.skuId,
                            coupon.subCouponId
                          )
                        }
                        className={`buy-btn ${
                          !isLoggedIn ? "disabled-look" : ""
                        }`}
                      >
                        Redeem
                      </button>
                      <button
                        disabled={
                          isLoggedIn &&
                          (loading ||
                            canAddToCart !== "Y" ||
                            serviceData.canAddToCart === "N")
                        }
                        className={`addtocart-btn ${
                          !isLoggedIn ? "disabled-look" : ""
                        }`}
                        onClick={(e) =>
                          handleAddToCartClick(
                            e,
                            serviceData.type,
                            serviceData.skuId,
                            coupon.subCouponId
                          )
                        }
                      >
                        <FontAwesomeIcon icon={faCartShopping} />
                      </button>
                    </div>
                  </div>
                </div>

                {/* Stock Message */}
                {serviceData.canAddToCart === "N" &&
                  serviceData.canAddToCartMessage && (
                    <div
                      className="d-flex flex-column align-items-center p-3 mt-3 mb-2"
                      style={{
                        background: "#fff9c4",
                        borderLeft: "6px solid #fbc02d",
                        borderRadius: "8px",
                        fontFamily: "'Segoe UI', Tahoma, sans-serif",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        fontSize: "15px",
                        width: "100%",
                        maxWidth: "100%",
                        padding: "12px 16px",
                      }}
                    >
                      <div className="d-flex align-items-center w-100">
                        <span
                          style={{
                            fontSize: "20px",
                            marginRight: "10px",
                            color: "#f57c00",
                          }}
                          role="img"
                          aria-label="warning"
                        >
                          ⚠️
                        </span>
                        <p
                          className="text-dark text-center mb-0 flex-grow-1"
                          style={{
                            fontWeight: 600,
                            lineHeight: "1.5",
                            margin: 0,
                            color: "#5d4037",
                            fontSize: "15px",
                          }}
                        >
                          {serviceData.canAddToCartMessage}
                        </p>
                      </div>
                    </div>
                  )}

                <hr />
              </>
            )}

            {/* Tabs */}
            <Tabs tabsList={tabsLists} />
          </div>
        </div>

        <Backdrop open={loading} style={{ zIndex: "10000" }}>
          <Spinner />
        </Backdrop>
        {/* BottomLogin Modal */}
        <BottomSheetCustom
          open={showLoginModal}
          handleClose={() => setShowLoginModal(false)}
          maxHeight="700px"
        >
          <BottomLogin onClose={() => setShowLoginModal(false)} />
        </BottomSheetCustom>
      </>
    </div>
  );
};
export default ChakraProductDetails;
